<template>
  <div class="inline-flex items-center pr-8px">
    <el-tooltip class="item" effect="dark" content="查看用户手册" placement="bottom">
      <el-button icon="el-icon-reading" type="text" @click="openUserManual"></el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="查看自研面积算法" placement="bottom">
      <el-button icon="el-icon-question" type="text" class="ml-[0]!" @click="openQuestion"></el-button>
    </el-tooltip>
    <Chat />
    <User @command="onCommandUser"></User>
    <el-dropdown trigger="click" @command="onCommandSetting">
      <el-button icon="el-icon-s-tools" type="text" @click="onClickTools"></el-button>
      <template #dropdown>
        <el-dropdown-menu class="py-4px">
          <el-dropdown-item command="about">关于系统</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script setup lang="ts">
import { MessageBox } from 'element-ui';
import Chat from './Chat/index.vue';
import User from './User/index.vue';
const userStore = useUserStore();
const router = useRouter();
const appStore = useAppStore();
const { ROSA_TITLE: title, ROSA_PLATFORM, appVersion: version } = storeToRefs(appStore);
const loginPage = useLoginPage();

const doLogout = async () => {
  await userStore.logout();
  router.push(loginPage);
};

const doAbout = () => {
  MessageBox({
    title: '',
    message: `
      <div class="text-center">
        <img src="/logos/${ROSA_PLATFORM.value || 'logo'}_rgb.png" style="margin:0 auto;width:180px;height:180px" alt="logo" />
        <p class="text-20px">${title.value}</p>
        <p class="mt-40px">版本：${version.value}</p>
      </div>
    `,
    dangerouslyUseHTMLString: true,
    showConfirmButton: false,
  });
};

const onCommandUser = (command: string) => {
  switch (command) {
    case 'logout':
      doLogout();
      break;
    case 'userInfo':
      router.push('/system/userSetting/userInfo');
      break;
  }
};

const onCommandSetting = (command: string) => {
  switch (command) {
    case 'about':
      doAbout();
  }
};

const onClickTools = () => {};

const openQuestion = () => {
  window.open('/asset/algorithm');
};

const openUserManual = () => {
  window.open('https://catbook.yuque.com/org-wiki-catbook-ttqz8o/aub8af');
};
</script>
<style lang="scss" scoped>
:deep {
  .el-button.el-button--text {
    padding: 5px 10px;

    i {
      font-size: 22px;
      color: white;
    }
  }
}
</style>
